import { styled } from '@mui/system';
import { Box, Link } from '@mui/material';
import { FilledButton } from 'ihp-components/components/Buttons';
import CircularProgress from '@mui/material/CircularProgress';

export const getStyles = (theme) => ({
  viewAllButton: {
    display: 'flex',
    alignSelf: 'stretch',
    alignItems: 'center',
    color: theme.palette.primary.main,
    padding: '10px 16px',
    justifyContent: 'center',
    gap: '12px',
  },
  icon: {
    fontSize: '14px',
  },
  hospitalIcon: {
    height: '45px',
    width: '45px',
    color: theme.palette.primary.white,
    background: theme.palette.primary.main,
    padding: '8px',
    borderRadius: '45px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  learnMoreButton: {
    textTransform: 'none',
    textAlign: 'center',
    fontStyle: 'normal',
    fontWeight: '600',
    lineHeight: '20px',
    letterSpacing: '0.28px',
    display: 'flex',
    padding: '13px 18px',
    justifyContent: 'center',
    alignItems: 'center',
    alignSelf: 'end',
    gap: '12px',
    borderRadius: '8px',
    border: '1px solid ' + theme.palette.primary.lightGray100,
    background: theme.palette.primary.white,
  },
});

export const Container = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'stretch',
  gap: '20px',
  width: '100%',
  [theme.breakpoints.down('sm')]: {
    backgroundColor: 'transparent',
    boxShadow: 'none',
    borderRadius: '0px',
  },
}));

export const Header = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
}));

export const Title = styled(Box)(({ theme }) => ({
  fontFamily: 'Inter',
  color: theme.palette.primary.darkGray100,
  fontSize: '24px',
  fontStyle: 'normal',
  fontWeight: '600',
  lineHeight: '145%',
  [theme.breakpoints.down('sm')]: {
    width: '100%',
    fontSize: '20px',
    fontStyle: 'normal',
    fontWeight: '600',
    lineHeight: '145%',
  },
}));

export const StyledLink = styled(Link)(({ theme }) => ({
  textDecoration: 'none',
  display: 'flex',
  alignSelf: 'stretch',
  alignItems: 'center',
  color: theme.palette.primary.main,
  padding: '10px 16px',
  justifyContent: 'center',
  gap: '12px',
  cursor: 'pointer',
  fontSize: '13px',
  fontStyle: 'normal',
  fontWeight: '600',
  lineHeight: '140%',
  letterSpacing: '0.26px',
  textAlight: 'center',
  [theme.breakpoints.down('sm')]: {
    display: 'none',
  },
}));

export const ViewAllButton = styled(FilledButton)(({ theme }) => ({
  display: 'none',
  padding: '15px 25px',
  justifyContent: 'center',
  alignItems: 'center',
  gap: '15px',
  alignSelf: 'stretch',
  borderRadius: '8px',
  background: theme.palette.primary.main,
  textAlign: 'center',
  fontSize: '15px',
  fontStyle: 'normal',
  fontWeight: '600',
  lineHeight: '135%',
  letterSpacing: '0.3px',
  [theme.breakpoints.down('sm')]: {
    width: '100%',
    display: 'flex',
  },
}));

export const Loader = styled(Box)(({ theme }) => ({
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}));

export const ResearchCircularProgress = styled(CircularProgress)(
  ({ theme }) => ({
    marginTop: '20px',
  })
);
